export default __webpack_public_path__ + "static/media/17_photo.1fb35c6a.jpg";